import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=73206cf4&scoped=true&"
import script from "./RoleCard.vue?vue&type=script&lang=ts&"
export * from "./RoleCard.vue?vue&type=script&lang=ts&"
import style0 from "./RoleCard.vue?vue&type=style&index=0&id=73206cf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73206cf4",
  null
  
)

export default component.exports